<section class="http-error-toasts" aria-live="polite" aria-label="HTTP errors" *ngIf="groups$ | async as groups">
  <div class="http-error-toasts__toolbar" [class.http-error-toasts__toolbar--leaving]="isToolbarLeaving" *ngIf="groups.length > 1">
    <button type="button" class="http-error-toast__action" (click)="copyAllVisible(groups)">
      <i [class]="isAllVisibleCopied ? 'ki-outline ki-check' : 'ki-outline ki-copy'" aria-hidden="true"></i>
      {{ (isAllVisibleCopied ? 'HTTP_ERROR_TOAST.COPIED_SUCCESSFULLY' : 'HTTP_ERROR_TOAST.COPY_ALL') | translate:{ count: groups.length } }}
    </button>
    <button type="button" class="http-error-toast__action http-error-toasts__close" (click)="dismissAll(groups)" [attr.aria-label]="'HTTP_ERROR_TOAST.DISMISS_ALL' | translate">
      <i class="ki-outline ki-cross" aria-hidden="true"></i>
    </button>
  </div>

  <article class="http-error-toast" [class.http-error-toast--leaving]="isLeaving(group)" *ngFor="let group of groups; trackBy: trackByKey">
    <div class="http-error-toast__details">
      <div class="http-error-toast__labels">
        <p class="http-error-toast__title">{{ 'HTTP_ERROR_TOAST.TITLE' | translate }}</p>
        <p class="http-error-toast__endpoint">{{ group.method }} {{ group.endpoint }}</p>
        <p class="http-error-toast__attempts">{{ 'HTTP_ERROR_TOAST.ATTEMPT_COUNT' | translate:{ count: group.attempts.length } }}</p>
      </div>
      <div class="http-error-toast__controls">
        <button type="button" class="http-error-toast__close" (click)="dismiss(group)" [attr.aria-label]="'HTTP_ERROR_TOAST.DISMISS' | translate">
          <i class="ki-outline ki-cross" aria-hidden="true"></i>
        </button>
        <button type="button" class="http-error-toast__action" (click)="copyLatest(group)">
          <i [class]="isCopied(group) ? 'ki-outline ki-check' : 'ki-outline ki-copy'" aria-hidden="true"></i>
          {{ (isCopied(group) ? 'HTTP_ERROR_TOAST.COPIED_SUCCESSFULLY' : 'HTTP_ERROR_TOAST.COPY') | translate }}
        </button>
      </div>
    </div>
  </article>
</section>
